export default __webpack_public_path__ + "static/media/ed3.3d7642ab.jpg";